/** Staggered entrance animation. CSS-driven so content can never be left
 *  invisible by an observer that fails to fire. */
export const Reveal = ({ children, delay = 0, className = "", as: Tag = "div", ...rest }) => (
  <Tag className={`anim-fade-up ${className}`} style={{ animationDelay: `${delay}ms` }} {...rest}>
    {children}
  </Tag>
);

export default Reveal;
